import { Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useParams } from "react-router-dom";
import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import AddYachtModal from "src/components/pages/Management/Yachts/AddYachtModal/AddYachtModal";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { ButtonsWrapper, Flex, PageContainer } from "src/styled";

import { type IOrganiozation } from "../Organizations.types";
import ManagementSearch from "../../../../../components/pages/Management/ManagementSearch/ManagementSearch";
import { useSelector } from "../../../../../redux/hooks";
import useRestricted from "../../../../../components/pages/Management/useRestricted";

const mapOrgs = (data: any) => {
  let list: IOrganiozation[] = [];
  if (data?.data?.content?.list) {
    list = data.data.content.list.map((el: IOrganiozation) => ({
      ...el,
      active: el.active ? "Yes" : null,
    }));
  }
  return { ...data?.data?.content, list };
};

const Yachts = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const { orgid } = useParams();
  const { isRestrictedToYacht } = useSelector(state => state.permsSlice);
  useRestricted([isRestrictedToYacht]);

  const requestBody = { _sect: "_clients", _org: orgid };

  const { data, isLoading, refetch } = useGetApi({
    request: "get-management",
    body: requestBody,
    mapper: mapOrgs,
  });

  return (
    <>
      <AddYachtModal opened={opened} close={close} refetch={refetch} />
      <PageContainer>
        <Breadcrumbs border={false}>
          <ButtonsWrapper>
            <Button variant="outline" onClick={open}>
              Add +
            </Button>
          </ButtonsWrapper>
        </Breadcrumbs>
        <Flex justify="end" mb={15}>
          <ManagementSearch
            section="_yachts"
            refetch={refetch}
            currentRequestParams={requestBody}
          />
        </Flex>
        <ManagementTable
          section="_yachts"
          data={data?.list ?? []}
          loading={isLoading}
        />
      </PageContainer>
    </>
  );
};

export default Yachts;
